import { z } from '@/libs/zod';
import { WithdrawReason, WithdrawStatus } from '@/types/enums';

const prizeSchema = z.object({
  id: z.string().optional(),
  name: z.string().optional(),
  type: z.string().optional(),
  sequenceRule: z.array(z.string()).optional(),
  sequence: z.array(z.string()).optional(),
  prizeValue: z.number().optional(),
  index: z.number().optional(),
  raffleId: z.string().optional(),
  raffleTicketId: z.string().optional(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

const withdrawSchema = z.object({
  id: z.string().optional(),
  status: WithdrawStatus,
  description: z.string().optional(),
  value: z.number().optional(),
  bankTransactionIdentifier: z.string().optional(),
  userId: z.string().optional(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
  deletedAt: z.date().optional(),
});

export const withdrawTransactionSchema = z.object({
  id: z.string(),
  status: WithdrawStatus,
  customerId: z.string(),
  value: z.number(),
  reason: WithdrawReason,
  description: z.string(),
  type: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
  prizeId: z.string(),
  prize: prizeSchema,
  withdrawId: z.string(),
  withdraw: withdrawSchema,
});

type WithdrawBase = z.infer<typeof withdrawSchema>;

export type Withdraw = WithdrawBase & {
  reasonRejection?: string;
};

type WithdrawTransactionBase = z.infer<typeof withdrawTransactionSchema>;

export type WithdrawTransaction = Omit<WithdrawTransactionBase, 'withdraw'> & {
  reasonRejection?: string;
  withdraw: Withdraw;
};
